import environments from 'config/environments.js';
import clientConfigs from 'config/clients.js';

export const clients = clientConfigs;
export default environments[process.env.REACT_APP_ENV] || environments.dev;
